var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75 9.5C6.57843 9.5 7.25 8.82843 7.25 8C7.25 7.17157 6.57843 6.5 5.75 6.5C4.92157 6.5 4.25 7.17157 4.25 8C4.25 8.82843 4.92157 9.5 5.75 9.5ZM5.75 9C6.30228 9 6.75 8.55228 6.75 8C6.75 7.44772 6.30228 7 5.75 7C5.19772 7 4.75 7.44772 4.75 8C4.75 8.55228 5.19772 9 5.75 9Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 4.5V3.75C9 1.95507 7.54493 0.5 5.75 0.5C3.95507 0.5 2.5 1.95507 2.5 3.75L2.50002 4.5H1.25C1.11193 4.5 1 4.61193 1 4.75V10.25C1 10.9404 1.55964 11.5 2.25 11.5H9.25C9.94036 11.5 10.5 10.9404 10.5 10.25V4.75C10.5 4.61193 10.3881 4.5 10.25 4.5H9ZM5.75 1C4.23122 1 3 2.23122 3 3.75L3.00002 4.5H8.5V3.75C8.5 2.23122 7.26878 1 5.75 1ZM1.5 5V10.25C1.5 10.6642 1.83579 11 2.25 11H9.25C9.66421 11 10 10.6642 10 10.25V5H1.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.75c3d4fc436cafd88eb1f8fcc4409732.svg";
export { ForwardRef as ReactComponent };